angular
  .module 'memberPortal'
  .controller 'MembershipPlanCtrl', (
    $scope,
    $state,
    $stateParams,
    $filter,
    $window,
    $http,
    DataService,
    membershipPlans,
    membershipPlan,
    membership
  ) ->
    $scope.data = DataService
    $scope.currency = DataService.currency
    $scope.hash = $stateParams.m
    $scope.membership = membership
    $scope.membershipPlan = membershipPlan
    $scope.paymentMethod =
      DataService.member_details.payment_method.data?.attributes || DataService.member_details.payment_method
    $scope.defaultDates = membershipPlan.default_dates
    $scope.pageParams =
      startDate: $scope.defaultDates.start_date || DataService.gym_today
    baseUrl = "/websites/#{DataService.domain}/members/"
    $scope.minDate = moment(DataService.gym_today).toDate()
    startDateLimitNumber = membershipPlan.member_portal_start_date_limit_number
    startDateLimitUnit = membershipPlan.member_portal_start_date_limit_unit
    $scope.maxDate = if startDateLimitNumber && startDateLimitUnit
      moment(DataService.gym_today).add(startDateLimitNumber, startDateLimitUnit).toDate()
    else
      moment(DataService.gym_today).add(364, 'days').toDate()

    $scope.startDateCanBeChanged = !membershipPlan.specified_start_date &&
      membershipPlan.allow_customer_to_choose_start_date_on_member_portal

    $scope.onDateChange = () ->
      params =
        gid: $scope.data.gym_id
        purchase_date: $scope.pageParams.startDate
      url = "/membership_defaults/#{membershipPlan.uuid}"
      $http.get(url, params: params).then (response) ->
        $scope.defaultDates = response.data

    unless DataService.member_details.can_purchase_memberships
      $state.go('memberPortal.bookings', m: $scope.getHash())

    $scope.showMembershipAlreadyExistsMessage = ->
      return false unless membership
      expirationDate = moment(membership.expiration_date)
      today = moment(DataService.member_details.gym_today)
      membership.expiration_date &&
        expirationDate.subtract(3, 'days').isAfter(today)

    $scope.isCard = (paymentMethod) ->
      return unless paymentMethod
      paymentMethod.card_expiration || paymentMethod.exp_year ||
        paymentMethod.payment_method is 'credit_card'

    $scope.isBankAccount = (paymentMethod) ->
      return unless paymentMethod
      paymentMethod.payment_method is 'bank_account' ||
        paymentMethod.card_brand is 'ACH'

    loadEzidebitFees = ->
      if $scope.data.member_details.gym_payment_provider isnt 'ezidebit' ||
        (!$scope.isCard($scope.paymentMethod) && !$scope.isBankAccount($scope.paymentMethod)) ||
        $scope.isFreeMembership
          return

      $http.get("/fee_schedules?gym_id=#{$scope.data.gym_id}").then (respose) ->
        $scope.fees = respose.data.fees

    loadEzidebitFees()

    $scope.isFreeMembership = !parseFloat(membershipPlan.cost_upfront) &&
      !parseFloat(membershipPlan.cost_repeat)

    $scope.isUpfront =
      parseFloat(membershipPlan.cost_upfront) > 0 && !parseFloat(membershipPlan.cost_repeat)

    $scope.isRecurring =
      parseFloat(membershipPlan.cost_repeat) > 0 && !parseFloat(membershipPlan.cost_upfront)

    $scope.isUpfrontAndRecurring =
      parseFloat(membershipPlan.cost_upfront) > 0 && parseFloat(membershipPlan.cost_repeat) > 0

    $scope.formattedDate = (date) ->
      moment(date).format('D MMM, YYYY')

    $scope.getHash = ->
      $stateParams.hash || $stateParams.m

    $scope.purchase = ->
      message = "Are you sure you want to purchase: #{membershipPlan.label}?"
      if $window.confirm(message)
        $scope.pageParams.isLoading = true
        url = "#{baseUrl}memberships"
        memberUrl = "#{baseUrl}members/#{DataService.member_details.id}"
        params =
          membership_plan_id: membershipPlan.id
          start_date: $scope.pageParams.startDate

        $http.post(url, params).then ->
          $scope.isPurchased = true
          $scope.pageParams.error = undefined
          $scope.pageParams.isLoading = false
          $http.get(memberUrl).then (response) ->
            DataService.member_details = response.data
        , (response) ->
          $scope.pageParams.isLoading = false
          $scope.pageParams.error = response.data.error
